import React from 'react';
import { AppBar, Toolbar, Typography, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import Logo from '../assets/images/logo-white.png';

const Header = ({ toggleSidebar, sidebarOpen }) => {
    return (
        <AppBar position="fixed"
            sx={{
                backgroundColor: '#1c1c40',
                color: '#fff',
                width: `calc(100% - ${sidebarOpen ? '240px' : '0px'})`, // Adjust width dynamically
                // transition: 'width 0.3s ease', // Smooth transition for width
                left: sidebarOpen ? '240px' : '0px', // Adjust header position if sidebar is open
                boxShadow: 2
            }}>
            <Toolbar>

                <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="menu"
                    onClick={toggleSidebar}
                    sx={{ mr: 2, color: '#fff' }}
                >
                    <MenuIcon />
                </IconButton>
                <img
                    src={Logo}
                    alt="Lawgeek Logo" className='header-logo'
                    style={{ marginRight: '0px' }}
                />

            </Toolbar>
        </AppBar>
    );
};

export default Header;
